module.exports = __webpack_public_path__ + "static/media/3-Diamond.a0d4b80b.svg";